import {Injectable} from "@angular/core";
import PubSub from "pubsub-js";
import {StorageKeysEnum} from "../../enums/storage-key.enum";

@Injectable({providedIn: 'root'})
export class ErrorTokenValidationService {

  private errorCodes: any = {
    TOKEN_01: {
      messageKey: "TOKEN_01",
      type: 'error',
      summary: 'Error',
    },
    TOKEN_02: {
      messageKey: "TOKEN_02",
      type: 'error',
      summary: 'Error',
    },
    TOKEN_03: {
      messageKey: "TOKEN_03",
      type: 'warning',
      summary: 'Warning',
    }
  }

  validateInvalidToken(error: any, translationValues: any) {
    if (error?.error?.errorCode && this.errorCodes[error.error.errorCode]) {
      const errorCodeConfig = this.errorCodes[error.error.errorCode];
      if (error.error.errorCode == "TOKEN_01" || error.error.errorCode == "TOKEN_02") {
        const errMsg = translationValues["TOKEN_02"];
        const toast = {message: errMsg, type: errorCodeConfig.type, summary: errorCodeConfig.summary};
        PubSub.publish(StorageKeysEnum.TOAST, toast);
        throw error.error;
      }
      if (error.error.errorCode === 'TOKEN_03') {
        //   @TODO implementar codigo de error TOKEN_03
      }
    }
  }
}
